<div class="control__wrapper bg-light">
    <div [ngClass]="{ 'control__shadow':
        control.elementVal.getValue()?.duringChange === 't' }">
    </div>
    <img class="control__img border-light"
         [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style bg-style__icon': control.elementVal.getValue()?.duringChange === 'f' }"
         ngSrc="{{ setIcon(control.elementVal.getValue()?.iconId) }}"
         width="72" height="72" alt="" />

    <h2 class="control__title"
        [ngClass]="{ 'bg-inactive': control.elementVal.getValue()?.duringChange === 't',
            'bg-style': control.elementVal.getValue()?.duringChange === 'f',
            'bg-style__label': control.elementVal.getValue()?.duringChange === 'f' }">
        {{ subtitle(control.elementVal.getValue()?.txtId) }}
    </h2>

    <div class="control__content">
        <div class=" control__group-btn">
            <button class="control__button control__button--switch"
                    [ngClass]="{ 'bg-cancel': control.elementVal.getValue()?.params.value === 0,
                        'bg-default': control.elementVal.getValue()?.params.value !== 0 }"
                    (click)="setValue(0)">
                <span class="control__select-btn color-light">
                    {{ subtitle(917) }}
                </span>
            </button>
            <button class="control__button control__button--switch"
                [ngClass]="{ 'bg-ok': control.elementVal.getValue()?.params.value === 1,
                    'bg-default': control.elementVal.getValue()?.params.value !== 1 }"
                    (click)="setValue(1)">
                <span class="control__select-btn  color-light">
                    {{ subtitle(1163) }}
                </span>
            </button>
        </div>
    </div>

    <div class="control__group-btn">
        <button class="control__button bg-default bg-default__button control__button--shadow-active"
            data-testid="goBackButton"
            (click)="control.hideControl()">
            <img class="control__button-img"
                 ngSrc="/assets/img/zone_icons/back.svg"
                 width="40" height="40" alt="" />
        </button>
        <button class="control__button control__button--small bg-default"
            data-testid="resetButton"
            (click)="setValue(control.elementVal.getValue()?.params.default)">
            <img class="control__button-img"
                ngSrc="/assets/img/icons/return.svg"
                width="40" height="40" alt="" />
        </button>
        <button class="control__button"
            [ngClass]="{ 'bg-default': control.elementVal.getValue()?.duringChange === 't',
                'bg-ok': control.elementVal.getValue()?.duringChange === 'f',
                'bg-ok--accept': control.elementVal.getValue()?.duringChange }"
                data-testid="sendButton"
                (click)="control.returnVal(control.elementVal.getValue()?.params.value)">
            <img class="control__button-img"
                 ngSrc="/assets/img/icons/ok.svg"
                 width="40" height="40" alt="" />
        </button>
    </div>

    <div *ngIf="control.elementVal.getValue()?.duringChange  === 't'"
         class="control__during-change">
        <p class="color-alarm font-18">{{ subtitle(3162) }}</p>
    </div>
</div>
